import { useQuery } from '@tanstack/react-query'
import getFeatureFlag from '../api/admin/getFeatureFlag'
import { GET_FEATURE_FLAG_KEY } from '../constants'

const useGetFeatureFlag = (
  flagName: string,
  contextObject?: Record<string, string>,
  enabled = true,
) => {
  return useQuery(
    [GET_FEATURE_FLAG_KEY, flagName, contextObject],
    () => getFeatureFlag(flagName, contextObject),
    { enabled },
  )
}

export default useGetFeatureFlag
